import Image from "next/image";
import Link from "next/link";
import { BsInstagram, BsLinkedin, BsTwitter } from "react-icons/bs";
import { LayoutWrapper } from "./layout-wrapper";
import { INSTAGRAM_LINK, LINKEDIN_LINK, TWITTER_LINK } from "./config/config";
import { openCookieSettings } from "./analytics/CookieConsent";

export default function Footer() {
    return (
        <footer className="border-t border-gray-200 bg-white text-sm text-gray-600">
            <LayoutWrapper>
                <div className="mx-auto">
                    <div className="border-t border-gray-200" />

                    {/* LINK GRID (ONLY OLD LINKS) */}
                    <div className="mx-auto grid grid-cols-1 lg:grid-cols-4 gap-12 py-4 md:py-8">
                        {/* Branding Section */}
                        <div>
                            <Link href="/" className="flex items-center space-x-3">
                                <img src="/logo2.png" alt="AI Interview Agents Logo" className="h-10 w-10 rounded-2xl shadow-lg object-cover" />
                                <span className="text-xl font-bold text-gray-700">
                                    AI Interview Agents
                                </span>
                            </Link>
                            <p className="mt-4 text-gray-900/80">
                                The AI interview and screening platform for hiring teams: real two-way interviews on web and phone, evidence-backed reports, and screening at scale.
                            </p>

                            {/* Social Media Links */}
                            <div className="flex space-x-4 mt-6">
                                <a href={TWITTER_LINK} target="_blank" rel="noopener noreferrer" className="text-gray-900/80 hover:text-blue-500">
                                    <BsTwitter size={20} />
                                </a>
                                <a href={INSTAGRAM_LINK} target="_blank" rel="noopener noreferrer" className="text-gray-900/80 hover:text-pink-500">
                                    <BsInstagram size={20} />
                                </a>
                                <a href={LINKEDIN_LINK} target="_blank" rel="noopener noreferrer" className="text-gray-900/80 hover:text-blue-700">
                                    <BsLinkedin size={20} />
                                </a>
                            </div>
                        </div>

                        {/* Links Section */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-4 gap-8">
                            <div>
                                <h4 className="text-gray-800 font-semibold mb-3">Platform</h4>
                                <ul className="space-y-2">
                                    <li><Link href="/recruiters" className="text-gray-900/80 hover:text-purple-600">Platform Overview</Link></li>
                                    <li><Link href="/recruiters/ai-interviewer" className="text-gray-900/80 hover:text-purple-600">AI Interviewer</Link></li>
                                    <li><Link href="/recruiters/ai-phone-screening" className="text-gray-900/80 hover:text-purple-600">Phone Screening</Link></li>
                                    <li><Link href="/recruiters/ai-video-interview-software" className="text-gray-900/80 hover:text-purple-600">AI Video Interview Software</Link></li>
                                    <li><Link href="/recruiters/interview-highlight-clips" className="text-gray-900/80 hover:text-purple-600">Interview Highlight Clips</Link></li>
                                    <li><Link href="/recruiters/ai-resume-screening" className="text-gray-900/80 hover:text-purple-600">Resume Screening</Link></li>
                                    <li><Link href="/recruiters/agentic-resume-search" className="text-gray-900/80 hover:text-purple-600">Agentic Search</Link></li>
                                    <li><Link href="/recruiters/career-page-builder" className="text-gray-900/80 hover:text-purple-600">Career Pages</Link></li>
                                    <li><Link href="/connect" className="text-gray-900/80 hover:text-purple-600">Connect Your AI</Link></li>
                                </ul>
                            </div>
                            <div>
                                <h4 className="text-gray-800 font-semibold mb-3">Resources</h4>
                                <ul className="space-y-2">
                                    <li><Link href="/blog" className="text-gray-900/80 hover:text-purple-600">Blog</Link></li>
                                    <li><Link href="/recruiters/ai-interview-software" className="text-gray-900/80 hover:text-purple-600">Buyer Guide 2026</Link></li>
                                    <li><Link href="/recruiters/ai-interview-bot" className="text-gray-900/80 hover:text-purple-600">AI Interview Bot</Link></li>
                                    <li><Link href="/candidates" className="text-gray-900/80 hover:text-purple-600">For Candidates</Link></li>
                                    <li><Link href="/tools" className="text-gray-900/80 hover:text-purple-600">Free Tools</Link></li>
                                </ul>
                            </div>
                            <div>
                                <h4 className="text-gray-800 font-semibold mb-3">Company</h4>
                                <ul className="space-y-2">
                                    <li><Link href="/about" className="text-gray-900/80 hover:text-purple-600">About</Link></li>
                                    <li><Link href="/contact" className="text-gray-900/80 hover:text-purple-600">Contact</Link></li>
                                </ul>
                            </div>
                            <div>
                                <h4 className="text-gray-800 font-semibold mb-3">Legal</h4>
                                <ul className="space-y-2">
                                    <li><Link href="/privacy-policy" className="text-gray-900/80 hover:text-purple-600">Privacy Policy</Link></li>
                                    <li><Link href="/terms-of-use" className="text-gray-900/80 hover:text-purple-600">Terms & Conditions</Link></li>
                                    <li><Link href="/refund-policy" className="text-gray-900/80 hover:text-purple-600">Refund Policy</Link></li>
                                    <li><button type="button" onClick={openCookieSettings} className="text-gray-900/80 hover:text-purple-600">Cookie settings</button></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* Bottom Divider */}
                    <div className="border-t border-gray-200" />

                    {/* BOTTOM BAR */}
                    <div className="py-6 text-center text-xs text-gray-500">
                        © 2026 AI Interview Agents. All rights reserved.
                    </div>

                </div>
            </LayoutWrapper>
        </footer>
    );
}
